"use client";
import React, { useEffect, useRef, useState } from "react";
export function InquiryCaptcha({ onState, attempt = 0, configUrl = "/api/inquiry-captcha" }) {
    const container = useRef(null);
    const callback = useRef(onState);
    const [error, setError] = useState("");
    useEffect(() => { callback.current = onState; }, [onState]);
    useEffect(() => {
        let active = true;
        let widget;
        let timer;
        callback.current("", false);
        async function load() {
            try {
                const response = await fetch(configUrl, { cache: "no-store" });
                if (!response.ok)
                    throw new Error("Configuration unavailable");
                const config = await response.json();
                if (!active)
                    return;
                if (config.enabled === false) {
                    setError("");
                    callback.current("", true);
                    return;
                }
                if (!config.siteKey)
                    throw new Error("Verification unavailable");
                if (!document.querySelector('script[data-inquiry-turnstile]')) {
                    const script = document.createElement("script");
                    script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
                    script.async = true;
                    script.dataset.inquiryTurnstile = "true";
                    document.head.appendChild(script);
                }
                const started = Date.now();
                function render() {
                    if (!active)
                        return;
                    if (!window.turnstile || !container.current) {
                        if (Date.now() - started > 15000) {
                            setError("Verification could not load. Check your connection and reload.");
                            return;
                        }
                        timer = setTimeout(render, 150);
                        return;
                    }
                    setError("");
                    widget = window.turnstile.render(container.current, {
                        sitekey: config.siteKey, action: "inquiry", size: "flexible",
                        callback: (token) => { if (active) {
                            setError("");
                            callback.current(token, true);
                        } },
                        "expired-callback": () => { if (active)
                            callback.current("", false); },
                        "error-callback": () => { if (active) {
                            callback.current("", false);
                            setError("Verification failed. Please retry or reload.");
                        } },
                    });
                }
                render();
            }
            catch {
                if (active)
                    setError("Verification is unavailable. Please reload or contact us directly.");
            }
        }
        void load();
        return () => { active = false; clearTimeout(timer); if (widget !== undefined)
            window.turnstile?.remove(widget); };
    }, [attempt, configUrl]);
    return <div><div ref={container}/>{error && <p role="alert" className="text-sm text-red-700">{error}</p>}</div>;
}
